import asyncActionTypes from '../../actions/types';
import TicketBilling from '../../../api-wrapper/ui-models/billing/ticketBilling';

const initialState = {
  ticketBillingArray: [],
  error: {
    actionType: '',
    actionable: '',
    code: '',
    codeAction: null,
    errorExtraInfo: '',
    errorMsg: '',
    errorUrl: '',
    event: '',
    statusCode: 0,
    type: '',
  },
  errorSingleBilling: false,
  loadingSingleBilling: false,
};

const singleBilling = ( state = initialState, action ) => {
  switch (action.type) {
    case asyncActionTypes.GET_SINGLE_BILLING.START:
      return {
        ...initialState,
        loadingSingleBilling: true,
      };
    case asyncActionTypes.GET_SINGLE_BILLING.SUCCESS:
      const ticketBillingArray = action?.payload.map((item) => new TicketBilling(item));
      return {
        ...state,
        ticketBillingArray: ticketBillingArray,
        loadingSingleBilling: false,
      };
    case asyncActionTypes.GET_SINGLE_BILLING.FAIL:
      return {
        ...initialState,
        error: {
          ...action?.error,
        },
        errorSingleBilling: true,
        loadingSingleBilling: false,
      };
    default:
      return state;
  }
};

export default singleBilling;